<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-04 19:29:03
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="商品信息">
				<el-input v-model="formData['product_search']" placeholder="请输入商品名称/ID"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { mapGetters } from 'vuex';
export default {
	name: 'search',
	props: {
		cate_info: {
			type: Array,
			default: () => [],
		},
		tabName: {
			type: [String, Number],
			default: '',
		},
	},
	computed: {
		...mapGetters(['dyCategoryList']),
		cateArr() {
			return this.dyCategoryList;
		},
	},
	data() {
		return {
			formData: {},
			labelWidth: '140px',
			promoteArr: [
				{
					label: '推广中',
					value: 1,
				},
				{
					label: '已失效-商品下架',
					value: 2,
				},
				{
					label: '已失效-活动失效',
					value: 3,
				},
				{
					label: '暂停推广',
					value: 4,
				},
			],
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.to_time = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
